<template>
  <LegalPage
    title="Disclaimer"
    subtitle="Information and risk notice"
    intro="The content on gbwhatsdroid.com is published for informational purposes only and does not replace professional, legal, or technical advice."
    :sections="sections"
    email="contact@gbwhatsdroid.com"
    page-name="disclaimer"
  />
</template>

<script>
import LegalPage from '@/components/LegalPage.vue';

export default {
  name: 'Disclaimer',
  components: {
    LegalPage,
  },
  data() {
    return {
      sections: [
        {
          heading: 'Independent Information Site',
          paragraphs: [
            'This website is an independent information resource. It is not the developer of GBWhatsApp, is not operated by WhatsApp Inc., and is not affiliated with Meta.',
            'Mentioning an application or linking to a download does not mean that we own the application, publish the APK, or provide official support for it.',
          ],
        },
        {
          heading: 'No Official Affiliation',
          paragraphs: [
            'WhatsApp is a trademark of WhatsApp LLC or its related companies. GBWhatsApp is an unofficial third-party modification.',
            'Use of product names is for identification and explanation only. The presence of a name on this page does not suggest endorsement by its owner.',
          ],
        },
        {
          heading: 'Download and Installation Risk',
          paragraphs: [
            'APK files can be altered by third parties. Installing modified messaging applications may carry security, compatibility, or account-related risks.',
          ],
          items: [
            'Only download files when you understand the source and are comfortable with the risk.',
            'Keep a current backup of chats and media before changing apps.',
            'Use up-to-date security software and review requested permissions.',
            'Understand that modified apps may not receive the same security patches as official apps.',
          ],
        },
        {
          heading: 'Accuracy and Availability',
          paragraphs: [
            'We try to keep the information current, but features, versions, links, and file availability can change without notice. The site does not guarantee that every download link will remain online or that every feature will work on every device.',
          ],
        },
        {
          heading: 'Limitation of Responsibility',
          paragraphs: [
            'To the fullest extent permitted by law, gbwhatsdroid.com is not responsible for loss, damage, device issues, account restrictions, or other outcomes resulting from the use of this site, linked files, or third-party applications.',
          ],
        },
      ],
    };
  },
};
</script>
